import React from 'react'
import Footerbar from '../Widgets/Footerbar'

function Footer() {
    return (
        <>
        <Footerbar/>
        </>
    )
}

export default Footer
